import Tracker from './Tracker';

const easyBookingTracker = new Tracker('easyBooking', {
	ACTIVATE: 'activate',
	COPY_LINK: 'copyLink',
	CREATE_APPOINTMENT: 'create'
});

export default easyBookingTracker;
